module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "inventory-list"
    }
  }, [_c('bc-navbar'), _vm._v(" "), (!_vm.isLoaded) ? _c('div', {
    staticClass: "loader-container",
    attrs: {
      "color": "#f9f300"
    }
  }, [_c('loader', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 25,
      "color": "#f9f300"
    }
  })], 1) : _c(_vm.inventoryComponentName, {
    tag: "component"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db82c4ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db82c4ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/inventory/inventory.vue
// module id = 818
// module chunks = 0